"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var SPACINGS_AFTER = {
  NONE: "none",
  SMALLEST: "smallest",
  SMALL: "small",
  NORMAL: "normal",
  MEDIUM: "medium",
  LARGE: "large",
  LARGEST: "largest"
};
var _default = SPACINGS_AFTER;
exports.default = _default;